// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AlertController from "./alert_controller";
application.register("alert", AlertController);

import BootstrapValidationController from "./bootstrap_validation_controller";
application.register("bootstrap-validation", BootstrapValidationController);

import GaugeCaptureController from "./gauge_capture_controller";
application.register("gauge-capture", GaugeCaptureController);

import GaugePhotoModalController from "./gauge_photo_modal_controller";
application.register("gauge-photo-modal", GaugePhotoModalController);

import StickyProjectTitleController from "./sticky_project_title_controller";
application.register("sticky-project-title", StickyProjectTitleController);

import TabulatorController from "./tabulator_controller";
application.register("tabulator", TabulatorController);

import ViewportLockController from "./viewport_lock_controller";
application.register("viewport-lock", ViewportLockController);
